import { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AuthContext from './contexts/AuthContext';
import { AlertContext } from './contexts/AlertContext';
import { AddProductPage } from './pages/AddProductPage';
import { HomePage } from './pages/HomePage';
import { Header } from './components/Header';
import { CollectionProductsPage } from './pages/CollectionProductsPage';
import { MoveProductsPage } from "./pages/MoveProductsPage";
import { ProductPage } from './pages/ProductPage';
import { ProductsPage } from './pages/ProductsPage';
import { AmplifyAuthenticator, AmplifySignIn } from '@aws-amplify/ui-react';
import { Auth } from '@aws-amplify/auth';
import { Hub } from 'aws-amplify';
import './scss/App.scss';
// import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import getUserPermissions from './utils/getUserPermissions';
import awsConfig from './aws-exports';
// New - Configuring Auth Module
Auth.configure(awsConfig);


function App() {
  const { state } = useContext(AlertContext);
  const [authState, setAuthState] = useState({
                                      loggedIn: false,
                                      email: null,
                                      phoneNumber: null,
                                      userPermissions: []
                                    });
  async function fetchUserAuth() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const userGroups = user.signInUserSession.accessToken.payload['cognito:groups'];
      const {email, phone_number} = user.attributes;
      // XXX: parse userGroups for the user permissions
      const userPermissions = await getUserPermissions();
      setAuthState({loggedIn: true, email, phoneNumber: phone_number, userGroups, userPermissions});
      // console.log('Permissions:', userGroups, userPermissions);
    } catch (err) {
      console.warn(err);
    }
  }
  // XXX: get auth on page load
  useEffect(() => {
    /* Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          // console.log('signIn', { user: data });
          break;
        case 'signOut':
          // console.log('signOut', { user: null });
          break;
        case 'customOAuthState':
          // console.log('customOAuthState', { customState: data });
          break;
        default:
          console.log('error', event, data);
      }
    }); */

    fetchUserAuth();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="App">
      {state.alert}
      <AuthContext.Provider value={{authState, setAuthState}}>
        <AmplifyAuthenticator>
          <AmplifySignIn
            headerText="Welcome to FaceCake&apos;s Asset Lab"
            hideSignUp="true"
            slot="sign-in"
            usernameAlias="email"
          >
            <div slot="federated-buttons"></div>
            <div slot="header-subtitle" className="text-right">
              <a href="/"
                onClick={(e) => {
                  e.preventDefault();
                  Auth.federatedSignIn({ provider: 'CHANEL' });
                }}
              >
                (Click here for CHANEL Sign-In)
              </a>
            </div>
          </AmplifySignIn>
          <Router>
              <Header />
            <Switch>
              <Route path="/products/search/:searchString">
                <ProductsPage />
              </Route>
              <Route path="/products/:collection/:productType/:noCacheStart?/:noCacheEnd?">
                <ProductsPage />
              </Route>
              <Route path="/products/:collection">
                <CollectionProductsPage />
              </Route>
              <Route path="/product/add/:collection/:productType">
                <AddProductPage />
              </Route>
              <Route path="/product/:collection/:productType/:productSKU">
                <ProductPage />
              </Route>
              <Route path="/move/:collection?/:productType?">
                <MoveProductsPage />
              </Route>
              <Route path="/home">
                <HomePage />
              </Route>
              <Route path="/">
                <HomePage />
              </Route>
            </Switch>
          </Router>
        </AmplifyAuthenticator>
      </AuthContext.Provider>
    </div>
  );
}

export default App;
